
    <div class="form-group">
        <div class="input-group image-upload">
            <div *ngIf="isPdf" class="fa fa-file-pdf-o red"></div>
            <br>
                  
            <div id="hide">
                <label class="">
                    <input type="file" [imageToDataUrl]="options" (imageSelected)="selected($event)" accept="image/*,application/pdf">
                    <span class="col-12 btn btn-sm btn-primary" style="cursor: pointer;">Upload Image</span>
                </label>
            </div>
            
            <span style="display: inline-block; text-align: center;">
                <img [src]="src" *ngIf="src && !isPdf" class="col-img img-fluid" style="padding:3px;border:1px solid #ccc;height:13em;">
            </span>
    
        </div>
    </div>
    
    

